import { Play } from "lucide-react";
import { toast } from "sonner";
import { FadeUp, MaskedReveal } from "./Reveal";

const VIDEO_URL = "https://customer-assets-lqy194kg.emergentagent.net/job_dutch-landing-hub/artifacts/83b0dyt2_HoeHetWerkt%2020261101.mpg.mp4";

const POSTER =
    "https://images.unsplash.com/photo-1606836591695-4d58a73eba1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBidXNpbmVzcyUyMG9mZmljZSUyMGFtc3RlcmRhbXxlbnwwfHx8fDE3ODgwODAyOTV8MA&ixlib=rb-4.1.0&q=85";

const VideoShowcase = () => (
    <section id="hoe-het-werkt" data-testid="video-showcase" className="relative bg-[#F9FAFB] py-24 md:py-32 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14">
                <div className="md:col-span-8">
                    <FadeUp>
                        <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#0047FF] mb-5">Hoe het werkt</p>
                    </FadeUp>
                    <h2 className="font-heading text-[#0A0A0A] font-bold tracking-tight text-4xl sm:text-5xl leading-[1.02]">
                        <MaskedReveal>Van jaarverslag naar</MaskedReveal>
                        <MaskedReveal delay={0.12} className="text-[#FF6B00]">kansberekening.</MaskedReveal>
                    </h2>
                </div>
                <FadeUp delay={0.2} className="md:col-span-4">
                    <p className="text-[#0A0A0A]/60 text-base leading-relaxed">
                        Bekijk de walkthrough en zie hoe MeerjarenplanOnline.nl in vier stappen van ruwe
                        cijfers naar een overtuigend investeringsverhaal gaat.
                    </p>
                </FadeUp>
            </div>

            <FadeUp delay={0.15}>
                <div className="relative rounded-2xl overflow-hidden blue-glow border border-black/10 aspect-video bg-[#0A0A0A]">
                    {VIDEO_URL ? (
                        <video data-testid="demo-video" controls preload="metadata" poster="/videos/how-it-works-poster.jpg" className="w-full h-full object-contain bg-[#0A0A0A]">
                            <source src="/videos/how-it-works.webm" type="video/webm" />
                            <source src={VIDEO_URL} type="video/mp4" />
                        </video>
                    ) : (
                        <>
                            <img
                                src={POSTER}
                                alt="MeerjarenplanOnline.nl walkthrough"
                                className="absolute inset-0 w-full h-full object-cover opacity-70"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/80 via-[#0A0A0A]/20 to-transparent" />
                            <button
                                data-testid="video-play-button"
                                onClick={() => toast.info("De videowalkthrough wordt hier binnenkort geplaatst.")}
                                className="absolute inset-0 flex items-center justify-center group"
                                aria-label="Video afspelen"
                            >
                                <span className="relative flex items-center justify-center">
                                    <span className="absolute w-24 h-24 rounded-full bg-[#0047FF]/60 animate-pulse-ring" />
                                    <span className="relative w-20 h-20 rounded-full bg-[#0047FF] flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                                        <Play className="w-8 h-8 text-white fill-white ml-1" />
                                    </span>
                                </span>
                            </button>
                            <div className="absolute bottom-6 left-6">
                                <p className="text-[10px] tracking-[0.25em] uppercase font-bold text-white/60">Walkthrough</p>
                                <p className="font-heading text-white text-2xl font-bold tracking-tight">MeerjarenplanOnline.nl in 4 stappen</p>
                            </div>
                        </>
                    )}
                </div>
            </FadeUp>
        </div>
    </section>
);

export default VideoShowcase;
